import request from '@/utils/request';

/**
 *   获取升级应用列表
 * @method getUpgradeAppList
 * @author LiYang
 * @return { request } axsio请求封装
 */
export function getUpgradeAppList(params) {
  return request({
    url: `/op/cunwapps/page`,
    method: 'get',
    params: params
  });
}
// 轮询时间配置查询
export function getTimeSet() {
  return request({
    url: `op/cunwappupgradepoll/`,
    method: 'get'
  });
}
// 轮询时间配置添加
export function addTimeSet(data) {
  return request({
    url: `op/cunwappupgradepoll/`,
    method: 'POST',
    data
  });
}
// 轮询时间配置删除
export function delTimeSet(id) {
  return request({
    url: `op/cunwappupgradepoll/${id}`,
    method: 'DELETE'
  });
}

/**
 *   根据packageName获取升级详情
 * @method getUpgradeAppDetail
 * @author LiYang
 * @return { request } axsio请求封装
 */
export function getUpgradeAppDetail(packageName) {
  return request({
    url: `/upgrademanages/info`,
    method: 'get',
    params: { packageName }
  });
}

/**
 *   新增升级
 * @method addApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function addApplicationUpgrade(form) {
  return request({
    url: `/op/cunwapps/`,
    method: 'post',
    data: form
  });
}

/**
 *   删除/禁用/启用应用升级
 * @method updateApplicationUpgradeStatus
 * @param  form
 * @return { request } axsio请求封装
 */
export function updateApplicationUpgradeStatus(form) {
  return request({
    url: `/op/cunwapps/batch-status`,
    method: 'post',
    data: form
  });
}

/**
 *   编辑升级
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function editApplicationUpgrade(id, form) {
  return request({
    url: `/op/cunwapps/${id}`,
    method: 'post',
    data: form
  });
}
// 设备类型列表
export function getDeviceTypeList() {
  return request({
    url: `op/cunwapps/getDevictDict`,
    method: 'get'
  });
}
// 查询校园软件应用下拉数据
export function schoolAppSelection() {
  return request({
    url: `/op/appConfig/schoolAppSelection`,
    method: 'get'
  });
}
// 查询家庭软件应用下拉数据
export function homeAppSelection() {
  return request({
    url: `/op/appConfig/homeAppSelection`,
    method: 'get'
  });
}
// 通过名称查询校园应用升级配置
export function selectSchoolConfig(params) {
  return request({
    url: `/op/appConfig/selectSchoolConfig`,
    method: 'get',
    params
  });
}
// 通过名称查询家庭应用升级配置
export function selectHomeConfig(params) {
  return request({
    url: `/op/appConfig/selectHomeConfig`,
    method: 'get',
    params
  });
}
